import { useHiringFlowCreate, useHiringFlows } from "@/queries/use-hiring-flows.query";
import {
  Button,
  Input,
  Modal,
  ModalProps,
  Select,
  Stack,
  Text,
  Title,
  useModals,
} from "@skailer-com/uikit";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { z } from "zod";

export function HiringFlowCreateModal(props: ModalProps) {
  const { t } = useTranslation();
  const { close } = useModals();
  const navigate = useNavigate();
  const { data: flows } = useHiringFlows();
  const create = useHiringFlowCreate();
  const createSchema = z.object({
    title: z.string().trim().min(1, t("errors:field_required")),
    copy_from_id: z.number().int().positive().nullable(),
  });
  const {
    register,
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<z.infer<typeof createSchema>>({
    mode: "onSubmit",
    resolver: zodResolver(createSchema),
    defaultValues: { title: "", copy_from_id: null },
  });
  const submit = handleSubmit(async (payload) => {
    try {
      const result = await create.mutateAsync(payload);
      close(props.id);
      navigate(`/settings/hiring-flows/${result.id}`);
    } catch {
      return;
    }
  });
  return (
    <Modal
      {...props}
      title={t("hiring_flow:new_template")}
      withCloser
      actions={
        <Button
          type="submit"
          size="lg"
          className="w-full"
          isLoading={isSubmitting}
          onClick={submit}
        >
          {t("common:create")}
        </Button>
      }
    >
      <form onSubmit={submit}>
        <Stack>
          <Input
            label={t("common:title")}
            required
            {...register("title")}
            error={errors.title?.message}
          />
          <Title header={t("hiring_flow:copy_from")} size="xs" paddingTop paddingBottom />
          <Controller
            name="copy_from_id"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Select
                emptyTitle={t("common:select")}
                options={flows ?? []}
                value={value}
                onChange={(id) => onChange(id == null ? null : Number(id))}
                label={t("hiring_flow:select_template")}
                error={errors.copy_from_id?.message}
              />
            )}
          />
          <Text className="text-secondary py-2 text-sm">{t("hiring_flow:copy_hint")}</Text>
        </Stack>
      </form>
    </Modal>
  );
}
